import { render, staticRenderFns } from "./BodyPositionView.vue?vue&type=template&id=45c972b6&scoped=true&"
import script from "./BodyPositionView.vue?vue&type=script&lang=ts&"
export * from "./BodyPositionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c972b6",
  null
  
)

export default component.exports